// 3rd Party
import React from 'react';
import { FileRejection } from 'react-dropzone';

// Components
import UploadStep from './UploadStep';
import ProcessingFile from '@/views/components/common/ProcessingFile';
import ExtractStep from './ExtractStep';
import TimeoutStep from './TimeoutStep';

// Types
import { AIStatementReaderSteps } from '../MultiPortfolioAiStatementReaderModal';
import { JobStatus } from '@/redux/api/ai-statement-reader';
import { JobStatusAndResults } from '@/redux/api/ai-statement-reader/ai-statement-reader-api';

type Props = {
  currentStep: AIStatementReaderSteps;
  uploadedFiles: File[];
  fileRejections: FileRejection[];
  isProcessingError: boolean;
  jobData: JobStatusAndResults | undefined;
  hasTimedOut: boolean;
  portfolioCount: number;
  onDrop: (acceptedFiles: File[], rejectedFiles: FileRejection[]) => void;
  onRemove: (file: File) => void;
};

const ModalBody: React.FC<Props> = ({
  currentStep,
  uploadedFiles,
  fileRejections,
  isProcessingError,
  jobData,
  hasTimedOut,
  portfolioCount,
  onDrop,
  onRemove,
}) => {
  if (currentStep === AIStatementReaderSteps.UPLOAD) {
    return (
      <UploadStep onDrop={onDrop} onRemove={onRemove} uploadedFiles={uploadedFiles} fileRejections={fileRejections} isProcessingError={isProcessingError} />
    );
  }

  if (currentStep === AIStatementReaderSteps.EXTRACTING) {
    return (
      <div className="processing-container">
        <ExtractStep portfolioCount={portfolioCount} />
      </div>
    );
  }

  if (currentStep === AIStatementReaderSteps.PROCESSING) {
    if (hasTimedOut) {
      return (
        <div className="processing-container">
          <TimeoutStep />
        </div>
      );
    }

    return (
      <div className="processing-container">
        <ProcessingFile
          isProcessing={jobData?.status === JobStatus.PROCESSING || !jobData}
          fileSize={uploadedFiles.reduce((acc, file) => acc + file.size, 0)}
        />
      </div>
    );
  }

  return null;
};

export default ModalBody;
